
import { Component, Vue } from "vue-property-decorator";

@Component
export class AppVersionPopup extends Vue {
  show = false
  detailData = null

  // 是否强制更新
  get isForcedUpdate () {
    // update为字符串"true"代表强更
    return this.detailData?.update === 'true'
  }

  showPopup (data: any) {
    this.show = true
    this.detailData = data
  }

  onYes () {
    if (!this.isForcedUpdate) {
      this.show = false
    }
    this.$bridge.callHandler('openAppStore', this.detailData)
  }
}
export default AppVersionPopup
